var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link ",attrs:{"to":'/' + _vm.to}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.headname)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }